import React, { useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Switch,
  FormControlLabel,
  Box
} from '@mui/material';
import { Close as CancelIcon, Add as CreateIcon } from '@mui/icons-material';
import { COLORS } from '../../../shared/colors';

const CreateTemplateForm = ({ onSave, onCancel, promptTypes }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: promptTypes?.[0] || '',
    content: '',
    isActive: false
  });

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleToggleChange = (event) => {
    setFormData(prev => ({
      ...prev,
      isActive: event.target.checked
    }));
  };

  const handleSave = () => {
    if (formData.name.trim() && formData.type && formData.content.trim()) {
      onSave(formData);
    }
  };

  const isValid = formData.name.trim() && formData.type && formData.content.trim();

  return (
    <div className="create-form">
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Create New Template
      </Typography>
      
      <div className="form-row">
        <TextField
          label="Template Name"
          placeholder="Enter template name"
          value={formData.name}
          onChange={handleChange('name')}
          fullWidth
        />
        
        <FormControl fullWidth>
          <InputLabel>Prompt Type</InputLabel>
          <Select
            value={formData.type}
            onChange={handleChange('type')}
            label="Prompt Type"
            displayEmpty
          >
            {(promptTypes || []).map((type, index) => (
              <MenuItem key={`${type}-${index}`} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      
      <TextField
        label="Template Content"
        placeholder="Enter template content..."
        value={formData.content}
        onChange={handleChange('content')}
        multiline
        rows={8}
        fullWidth
        size="small"
      />
      
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        💡 Use placeholders: {'{'}{'{'} customerName {'}'}{'}'},  {'{'}{'{'} projectTitle {'}'}{'}'},  {'{'}{'{'} deadline {'}'}{'}'},  {'{'}{'{'} requirements {'}'}{'}'}  for dynamic content
      </Typography>
      
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.isActive}
              onChange={handleToggleChange}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: COLORS.success,
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: COLORS.success,
                },
              }}
            />
          }
          label={
            <Typography variant="body2" color="text.secondary">
              {formData.isActive ? 'Set as Active Template' : 'Keep Inactive'}
            </Typography>
          }
        />
        
        <Box display="flex" gap={1}>
          <Button
            onClick={onCancel}
            variant="outlined"
            startIcon={<CancelIcon />}
            sx={{ 
              color: COLORS.gray[600],
              borderColor: COLORS.gray[300],
              bgcolor: 'white',
              '&:hover': {
                bgcolor: COLORS.gray[50],
                borderColor: COLORS.gray[400]
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            startIcon={<CreateIcon />}
            disabled={!isValid}
            sx={{ 
              bgcolor: COLORS.primary,
              boxShadow: 2,
              '&:hover': {
                bgcolor: COLORS.blue[600],
                boxShadow: 3
              }
            }}
          >
            Create Template
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default CreateTemplateForm;